import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-200/70 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <a href="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-grid-line text-background-50 text-base"></i>
              </div>
              <span className="text-base font-heading font-semibold text-foreground-950">
                Sugargoo <span className="text-primary-500">Spreadsheet</span>
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Your trusted resource for Sugargoo Spreadsheet product databases, shopping guides, and expert reviews. Helping shoppers discover better products since 2024.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Visit Main Website
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Home</a>
              </li>
              <li>
                <a href="/article/what-is-sugargoo-spreadsheet" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Complete Guide</a>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Sugargoo Spreadsheet</a>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Buy It Now</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Popular Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">More Categories</h4>
            <ul className="space-y-2.5">
              {categories.slice(6).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-300/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} Sugargoo Spreadsheet. All rights reserved. This is an independent resource and is not affiliated with Sugargoo.
            </p>
            <div className="flex items-center gap-4">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">Privacy</a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">Terms</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}